// MUST be the first import: it registers the vue-router in-component guards with
// vue-class-component, which only takes effect for classes decorated afterwards.
// Any import above this line pulls in a component that would be decorated too
// early and lose its beforeRouteLeave/beforeRouteUpdate. See the module itself.
import './class-component-hooks'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
